'use client';

import GloryBorder from './glory-border';
import { montserratMedium, montserratExtraBold, montserratSemi } from "../fonts";

type RoadmapItem = {
  id: number;
  period: string;
  title: string;
  description: string;
};

interface RoadmapMobileProps {
  items: RoadmapItem[];
}

export default function RoadmapMobile({ items }: RoadmapMobileProps) {
  return (
    <div className="relative pl-6">
      {/* Timeline line - left aligned for mobile */}
      <div className="absolute left-2 w-0.5 h-full bg-gradient-to-b from-[color:var(--main-color)] via-[color:var(--main-color)] to-transparent opacity-30"></div>
      <div className="space-y-6 -ml-[23px]">
        {items.map((item) => (
          <div key={item.id} className="relative flex flex-row items-start gap-3">
            <div
              className="w-4 h-4 rounded-full border-4 border-[color:var(--background)]"
              style={{ background: 'linear-gradient(180deg, #FFFFFF, #8B9CB6, #2F4D7D)' }}
            />
            <div className="w-full">
              <GloryBorder>
                <div className="bg-[#030303] w-full border-1 border-[var(--field-border)] rounded-2xl min-h-[160px] p-4 flex flex-col gap-2">
                  <div className={`${montserratSemi.className} text-sm text-[color:var(--main-color)]`}>
                    {item.period}
                  </div>
                  <h3 
                    className={`${montserratExtraBold.className} text-lg text-white`}
                    dangerouslySetInnerHTML={{ __html: item.title }}
                  />
                  <p className={`${montserratMedium.className} text-sm text-[color:var(--text-muted)] leading-relaxed`}>
                    {item.description}
                  </p>
                </div>
              </GloryBorder>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}


